module.exports = __webpack_public_path__ + "img/home_business_0.38f140c7.png";